import { history } from 'umi';

export const normalizeSearchParamsString = (search?: string | null): string => {
  return (search || '').replace(/^\?+/, '');
};

/** 统一调试面板中的 search 展示，空查询展示为 (empty) */
export const formatSearchParamsForDisplay = (search?: string | null): string => {
  const normalizedSearch = normalizeSearchParamsString(search);

  return normalizedSearch ? `?${normalizedSearch}` : '(empty)';
};

/** 同时兼容 Umi history 和浏览器 location，优先使用 Umi 当前路由 */
const getCurrentLocationParts = (): {
  pathname: string;
  search: string;
  hash: string;
} => {
  const browserLocation = typeof window === 'undefined' ? null : window.location;
  const historyLocation = history?.location;

  return {
    pathname: historyLocation?.pathname ?? browserLocation?.pathname ?? '',
    search: historyLocation?.search ?? browserLocation?.search ?? '',
    hash: historyLocation?.hash ?? browserLocation?.hash ?? '',
  };
};

/** 获取当前 URL 查询字符串，返回值不带问号 */
export const getCurrentSearchParamsString = (): string => {
  return normalizeSearchParamsString(getCurrentLocationParts().search);
};

/**
 * 替换当前 URL 查询参数。
 * query 中的空值会删除对应 key，deleteQuery 会额外清理短链或受控 URL 字段。
 */
export const replaceCurrentSearchParams = (query: IRecord<any>, deleteQuery?: string[]): void => {
  const { pathname, search, hash } = getCurrentLocationParts();
  const searchParams = new URLSearchParams(normalizeSearchParamsString(search));

  if (query && Object.prototype.toString.call(query) === '[object Object]') {
    Object.entries(query).forEach(([key, value]) => {
      if (key) {
        if (value === undefined || value === null || value === '') {
          searchParams.delete(key);
          return;
        }

        searchParams.set(key, String(value));
      }
    });
  }

  if (Array.isArray(deleteQuery) && deleteQuery.length > 0) {
    deleteQuery.forEach((key) => {
      if (searchParams.has(key)) {
        searchParams.delete(key);
      }
    });
  }

  const searchParamsStr = searchParams.toString();
  const nextLocation = {
    pathname,
    search: searchParamsStr ? `?${searchParamsStr}` : '',
    hash,
  };

  if (history?.replace) {
    history.replace(nextLocation);
    return;
  }

  const browserHistory = typeof window === 'undefined' ? null : window.history;
  browserHistory?.replaceState?.(null, '', `${pathname}${nextLocation.search}${hash}`);
};
